<ng-container>
    <h2 mat-dialog-title>
        Войти или создать профиль
    </h2>
    <div class="error" *ngIf="auth.getError">{{auth.getError}}</div>
    <form action="" *ngIf="!auth.token; else code" [formGroup]="phoneGroup">
        <div class="main">
            <div class="input-phone" >
                <div class="input-label">Ваш телефон</div>
                <input type="text" formControlName="phone">
            </div>
            <div class="input-button" (click)="getCode()">
                <button>Войти</button>
            </div>
        </div>
    </form>
    <ng-template #code>
        <mat-icon (click)="backward()" class="backward">arrow_back</mat-icon>
        <form action="" [formGroup]="authGroup">
            <div class="main">
                <div class="input-phone" >
                    <div class="input-label">Введите полученный код</div>
                    <input type="text" formControlName="code">
                </div>
                <div class="input-button" (click)="signWB()">
                    <button>Войти</button>
                </div>
            </div>
        </form>
    </ng-template>

    <div class="others">
        <div class="others-title">
            Другие способы
        </div>
        <button mat-raised-button (click)="auth.signInWithFB()" type="button" class="btn btn-lg btn-fb">
            <i class="fab fa-facebook-f pr-1"></i>
        </button>
    </div>
            
       
        <!--<mat-list-item>
            <button mat-raised-button (click)="auth.signInWithGoogle()" type="button" class="btn btn-lg btn-gplus"><i class="fab fa-google pr-1"></i> Google</button>
        </mat-list-item>--> 
</ng-container>

